import React, { useState, useEffect } from "react";
import { Select } from "antd";

const StatusSelect = ({
  statusOptions,
  originalList,
  onFilteredListChange,
  statusField = "status", // The field name to filter by
  defaultStatus = "active", // The default status to select
  useRawValue = false, // Whether to use raw value from nested object
  rawValuePath = "otherKeys.statusValue", // Path to raw value if useRawValue is true
  placeholder = "Select status",
  ...otherProps
}) => {
  // TODO : Review
  const [selectedStatus, setSelectedStatus] = useState(defaultStatus ?? "active");
  // Helper function to get nested value from object
  const getNestedValue = (obj, path) => {
    return path.split(".").reduce((current, key) => current?.[key], obj);
  };

  const handleStatusChange = (value) => {
    setSelectedStatus(value);

    let filteredList = originalList;

    if (value.toLowerCase() === "status") {
      // "All Status" case - return original list
      filteredList = originalList;
    } else {
      // Filter by the selected status
      filteredList = originalList.filter((item) => {
        let itemStatus;

        if (useRawValue) {
          // Use raw value from nested path
          itemStatus = getNestedValue(item, rawValuePath);
        } else {
          // Use direct field value
          itemStatus = item[statusField];
        }

        const itemStatusLower = itemStatus?.toString().toLowerCase();
        const selectedValue = value.toLowerCase();

        // console.log(
        //   "Item status:",
        //   itemStatusLower,
        //   "Selected:",
        //   selectedValue,
        //   "Match:",
        //   itemStatusLower === selectedValue
        // );

        return itemStatusLower === selectedValue;
      });
    }

    // console.log(
    //   "Original list length:",
    //   originalList.length,
    //   "Filtered length:",
    //   filteredList.length
    // );

    // Pass the filtered list back to parent
    onFilteredListChange(filteredList);
  };

  // Initial filter on mount or when originalList changes
  useEffect(() => {
    if (originalList && originalList.length > 0) {
      handleStatusChange(defaultStatus ?? "active");
    }
  }, [originalList, defaultStatus]);

  // useEffect(() => {
  //   if (originalList && originalList.length > 0) {
  //     handleStatusChange("active");
  //   }
  // }, [originalList]);

  return (
    <div style={{ marginBottom: "auto", marginLeft: 10 }}>
      <Select
        value={selectedStatus}
        options={statusOptions}
        onChange={handleStatusChange}
        placeholder={placeholder}
        {...otherProps}
        dropdownStyle={{ width: "250px" }}
        className="interbank-table-select"
      />
    </div>
  );
};

export default StatusSelect;
